import React, { useEffect } from 'react';
import { IStep, IStepData } from '../..';
import { appTheme } from '../../../../theme';
import {
  Container, Description, Item, RadioContainer,
  Radio, RadioInner, LabelContainer, Label,
  Title, List,
} from './styles';

export interface ISetCurrentPracticeScreenProps {
  step: IStep;
  onClick: (value: any) => void;
  setButtonDisabled: (set: boolean) => void;
  distance?: number | null;
  currentPractice?: string;
}

function SetCurrentPracticeScreen({
  step, distance, currentPractice, onClick, setButtonDisabled,
}: ISetCurrentPracticeScreenProps) {
  useEffect(() => {
    if (currentPractice) setButtonDisabled(false);
    else setButtonDisabled(true);
  }, [currentPractice]);

  return (
    <Container>
      <Title>{step.title}</Title>

      {!!step.description && <Description>{step.description}</Description>}

      <List>
        {
          step.data.map((item: IStepData) => distance === item.distance && (
            <Item
              key={item.label}
              onClick={() => onClick(item.value)}
              style={{ borderColor: `${currentPractice === item.value ? appTheme.gray : appTheme.cardB3}` }}
            >
              <RadioContainer>
                <Radio
                  style={{
                    backgroundColor: currentPractice === item.value ? appTheme.title : appTheme.cardB3,
                  }}
                >
                  <RadioInner
                    style={{
                      backgroundColor: currentPractice === item.value ? appTheme.title : appTheme.cardB3,
                    }}
                  />
                </Radio>
              </RadioContainer>

              <LabelContainer>
                <Label>{(item.label as string).toUpperCase()}</Label>
              </LabelContainer>
            </Item>
          ))
        }
      </List>
    </Container>
  );
}

export default SetCurrentPracticeScreen;
